import React from 'react'
import { SvgIcon } from '@material-ui/core'

interface TProps {
  size?: number
}

export const CirrusIcon: React.FC<TProps> = ({ size }) => (
  <SvgIcon>
    <svg
      fill='none'
      viewBox='0 0 560 560'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M393.984 347.951C381.219 347.951 369.704 353.172 361.372 361.562L353.19 369.743C344.248 378.684 329.624 378.684 320.682 369.743L310.477 359.539C305.374 355.002 299.244 351.595 292.475 349.691C288.488 348.561 284.307 347.936 279.963 347.936C267.957 347.936 257.037 352.562 248.854 360.104L239.198 369.758C230.346 378.609 215.93 378.684 206.974 370.011L190.207 353.247C181.266 344.306 181.266 329.684 190.207 320.744L197.958 312.994H197.824C198.761 312.101 199.729 311.209 200.591 310.227C205.025 305.154 208.343 299.085 210.217 292.406C211.333 288.434 211.958 284.284 211.958 279.955C211.958 267.252 206.795 255.753 198.449 247.423L190.222 239.197C181.28 230.257 181.28 215.634 190.222 206.694L206.989 189.929C215.945 181.257 230.361 181.331 239.213 190.182L248.869 199.836C257.051 207.378 267.972 212.004 279.978 212.004C284.322 212.004 288.502 211.365 292.49 210.249C299.244 208.345 305.388 204.939 310.491 200.402L320.697 190.197C329.639 181.257 344.263 181.257 353.205 190.197L361.387 198.379C369.719 206.768 381.234 211.99 393.999 211.99C419.395 211.99 440 191.402 440 165.995C440 140.588 419.41 120 393.999 120C381.948 120 371.028 124.656 362.83 132.242L360.316 134.771L353.205 141.882C344.263 150.822 329.639 150.822 320.697 141.882L314.776 135.961C313.333 134.295 311.771 132.733 310.105 131.276C302.041 124.269 291.523 120.015 280.007 120.015C268.224 120.015 257.513 124.478 249.39 131.752L245.745 135.396L239.258 141.867C230.317 150.807 215.692 150.807 206.751 141.867L196.679 131.796C188.541 124.478 177.814 120 166.001 120C140.59 120 120 140.588 120 165.995C120 177.627 124.329 188.248 131.456 196.356C132.646 197.709 133.94 198.974 135.294 200.193L141.825 206.724C150.767 215.664 150.767 230.286 141.825 239.226L132.467 248.583C124.761 256.809 120.015 267.832 120.015 279.985C120.015 291.424 124.195 301.867 131.113 309.914C132.244 311.238 133.524 312.428 134.803 313.618H134.669L141.825 320.774C150.767 329.714 150.767 344.336 141.825 353.276L135.294 359.807C133.94 361.026 132.646 362.291 131.456 363.645C124.329 371.752 120 382.373 120 394.005C120 419.412 140.59 440 166.001 440C177.814 440 188.541 435.523 196.679 428.204L206.751 418.133C215.692 409.193 230.317 409.193 239.258 418.133L245.745 424.604L249.39 428.248C257.513 435.537 268.224 439.985 280.007 439.985C291.537 439.985 302.056 435.731 310.105 428.724C311.771 427.282 313.348 425.72 314.776 424.039L320.697 418.118C329.639 409.178 344.263 409.178 353.205 418.118L360.316 425.229L362.83 427.758C371.028 435.344 381.948 440 393.999 440C419.395 440 440 419.412 440 394.005C439.985 368.539 419.38 347.951 393.984 347.951Z'
        fill='white'
      />
      <g>
        <path
          d='M160 0C137.904 0 120 17.9172 120 40C120 62.0957 137.904 80 160 80C182.096 80 200 62.0957 200 40C200 17.9172 182.096 0 160 0Z'
          fill='white'
        />
        <path
          d='M280 0C257.904 0 240 17.9172 240 40C240 62.0957 257.917 80 280 80C302.083 80 320 62.0957 320 40C320 17.9172 302.083 0 280 0Z'
          fill='white'
        />
        <path
          d='M400.006 0C377.914 0 360 17.9172 360 40C360 62.0957 377.901 80 400.006 80C422.086 80 440 62.0957 440 40C440 17.9172 422.086 0 400.006 0Z'
          fill='white'
        />
        <path
          d='M280 240C257.904 240 240 257.914 240 279.994C240 302.086 257.917 320 280 320C302.083 320 320 302.099 320 279.994C320 257.901 302.083 240 280 240Z'
          fill='white'
        />
        <path
          d='M400.006 240C377.914 240 360 257.914 360 279.994C360 302.086 377.901 320 400.006 320C422.086 320 440 302.099 440 279.994C440 257.901 422.086 240 400.006 240Z'
          fill='white'
        />
        <path
          d='M160 480C137.904 480 120 497.904 120 520C120 542.096 137.904 560 160 560C182.096 560 200 542.096 200 520C200 497.917 182.096 480 160 480Z'
          fill='white'
        />
        <path
          d='M280 480C257.904 480 240 497.904 240 520C240 542.096 257.917 560 280 560C302.083 560 320 542.096 320 520C320 497.917 302.083 480 280 480Z'
          fill='white'
        />
        <path
          d='M400.006 480C377.914 480 360 497.904 360 520C360 542.096 377.901 560 400.006 560C422.086 560 440 542.096 440 520C440 497.917 422.086 480 400.006 480Z'
          fill='white'
        />
        <path
          d='M520 480C497.904 480 480 497.904 480 520C480 542.096 497.904 560 520 560C542.083 560 560 542.096 560 520C560 497.917 542.083 480 520 480Z'
          fill='white'
        />
        <path
          d='M40 480C17.9043 480 0 497.904 0 520C0 542.096 17.9043 560 40 560C62.0957 560 80 542.096 80 520C80 497.904 62.0957 480 40 480Z'
          fill='white'
        />
        <path
          d='M40 360C17.9043 360 0 377.904 0 400C0 422.096 17.9043 440 40 440C62.0957 440 80 422.096 80 400C80 377.904 62.0957 360 40 360Z'
          fill='white'
        />
        <path
          d='M40 240C17.9043 240 0 257.914 0 279.994C0 302.086 17.9043 320 40 320C62.0957 320 80 302.099 80 279.994C80 257.901 62.0957 240 40 240Z'
          fill='white'
        />
        <path
          d='M40 120C17.9043 120 0 137.904 0 160C0 182.096 17.9043 200 40 200C62.0957 200 80 182.096 80 160C80 137.904 62.0957 120 40 120Z'
          fill='white'
        />
        <path
          d='M40 0C17.9043 0 0 17.9172 0 40C0 62.0957 17.9043 80 40 80C62.0957 80 80 62.0957 80 40C80 17.9172 62.0957 0 40 0Z'
          fill='white'
        />
        <path
          d='M519.994 360C497.914 360 480 377.904 480 400C480 422.096 497.901 440 519.994 440C542.086 440 560 422.096 560 400C560 377.904 542.086 360 519.994 360Z'
          fill='white'
        />
        <path
          d='M519.994 240C497.914 240 480 257.914 480 279.994C480 302.086 497.901 320 519.994 320C542.086 320 560 302.099 560 279.994C560 257.901 542.086 240 519.994 240Z'
          fill='white'
        />
        <path
          d='M519.994 120C497.914 120 480 137.904 480 160C480 182.096 497.901 200 519.994 200C542.086 200 560 182.096 560 160C560 137.904 542.086 120 519.994 120Z'
          fill='white'
        />
        <path
          d='M519.994 80C542.086 80 560 62.0957 560 40C560 17.9172 542.086 0 519.994 0C497.914 0 480 17.9172 480 40C480 62.0828 497.914 80 519.994 80Z'
          fill='white'
        />
      </g>
    </svg>
  </SvgIcon>
)
